import React, { Suspense } from 'react';
import { LinearProgress } from '@mui/material';
import { RouteProps } from 'react-router-dom';

import { authRoutesConfig } from '@homesusa/auth';
import { ErrorRoutes } from '../components/routes/error-routes.component';
import { PrivateRoute } from '../components';

const HelpSection = React.lazy(() => import('../components/help/help.component'));

const helpComponent = (
  <Suspense fallback={<LinearProgress />}>
    <HelpSection />
  </Suspense>
);

export const appPrivateRoutesConfig: RouteProps[] = [
  {
    path: 'help',
    element: helpComponent
  }
];

export const appPublicRoutesConfig: RouteProps[] = [
  ...authRoutesConfig,
  {
    path: 'error/*',
    element: <ErrorRoutes />
  }
];

export const appRoutesConfig = [
  ...appPublicRoutesConfig,
  {
    path: 'help',
    element: <PrivateRoute />,
    children: [
      {
        index: true,
        element: helpComponent
      }
    ]
  }
];
